module.exports = __webpack_public_path__ + "static/media/btn_organisation_1075_725.f059cbd1.png";